import { useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useScheduleQuery } from "../../../hooks/api/useSchedule";
import PageTemplate from "../../templates/PageTemplate";
import Error from "../../organisms/Error";
import ApplicationForm from "./ApplicationForm";
import ActivityForm from "../activity/ActivityForm";
import { useEffect } from "react";
import Loading from "../../organisms/Loading";
import ActivityTransfer from "../activity/ActivityTransfer";

const Application = () => {
	const { idx, pageType } = useParams();
    const idxParams = new URLSearchParams("?" + window.atob(idx));
	const eventIdx = idxParams.get("eventIdx");
	const scheduleIdx = idxParams.get("scheduleIdx");
    const navigate = useNavigate();
    
	const customersInfo = useSelector(state => state.customers).value;
    const primaryCustomer = customersInfo.filter(v => v.isPrimary)[0]; // 주사업자
	const scheduleQuery = useScheduleQuery(scheduleIdx, primaryCustomer?primaryCustomer.uid:"");

    useEffect(() => {
        if (scheduleQuery.data) {
            document.title = `${window.location.hostname == "localhost" ? "(local) " : ""}${scheduleQuery.data?.title} - ${scheduleQuery.data?.order}차수`;
        }
    },[scheduleQuery.data]);

    useEffect(() => {
        scheduleQuery.refetch();
    }, [pageType]);

    if (scheduleQuery.isLoading) {
        return (
            <PageTemplate title="">
                <Loading layer={true}/>
            </PageTemplate>
        )
    }

    {/* 신청기간 외 화면 */}
    if (scheduleQuery.isError) {
        if (scheduleQuery.error.response) {
            const title = scheduleQuery.error.response.data.data?.title ? scheduleQuery.error.response.data.data?.title : "";
            const order = scheduleQuery.error.response.data.data?.order ? scheduleQuery.error.response.data.data?.order : ""
            return (
                <PageTemplate title={(title && order) ? `${title} - ${order} 차수` : ""}>
                    <Error msg={scheduleQuery.error?.response.data?.msg?.ko ? scheduleQuery.error?.response.data.msg.ko.replace("/\n/g", <br/>) : "오류가 발생했습니다."}/>
                </PageTemplate>
            )
        } else {
            return (
                <PageTemplate>
                    <Error msg={"오류가 발생했습니다."}/>
                </PageTemplate>
            )
        }
    }

    const getPage = () => {
        const applicationIdx = scheduleQuery.data.application_idx;

        // 액티비티 양도/양수 — 신청서 제출 여부와 무관하게 접근 가능
        if (pageType === "activityTransfer") {
            // 액티비티 양도 기능이 비활성화되거나 2차 신청기간이 아닌 경우 접근 차단
            if (scheduleQuery.data?.target !== "activity" || Number(scheduleQuery.data?.activity_transfer_enabled) !== 1) {
                return <Error msg={"액티비티 양도 기능이 비활성화 되어있거나\n2차 신청기간이 아닙니다."} />;
            }
            return (
                <ActivityTransfer
                    scheduleIdx={scheduleIdx}
                    urlPath={idx}
                />
            )
        }

        // 1-1. 신청 정보 있는 경우
        if (applicationIdx) {
            // 2-1. 고객 정보 수정페이지
            if (pageType === "modify") {
                return (
                    <ApplicationForm 
                        target={scheduleQuery.data.target} 
                        eventIdx={eventIdx}
                        scheduleIdx={scheduleIdx}
                        applicationIdx={applicationIdx}
                        urlPath={idx}
                    />
                )
            }

            // 2-2. 액티비티 신청 페이지
            if (pageType === "activity") {
                return (
                    <ActivityForm 
                        scheduleIdx={scheduleIdx} 
                        applicationIdx={applicationIdx}
                        target={scheduleQuery.data.target}
                        urlPath={idx}
                    />
                )
            }

            // 2-3. 신청 완료 페이지
            return <Navigate to={"/application/complete/" + applicationIdx + "/" + scheduleIdx} replace />;
        } 
        // 1-2. 신청 정보 없는 경우
        else {
            return (
                <ApplicationForm 
                    target={scheduleQuery.data.target} 
                    eventIdx={eventIdx}
                    scheduleIdx={scheduleIdx}
                    urlPath={idx}
                />
            )
        }
    }

    if (scheduleQuery.data) {
        return (
            <PageTemplate title={`${scheduleQuery.data?.title} - ${scheduleQuery.data?.order}차수`} showBack={true}>
                {getPage()}
            </PageTemplate>
        )
    }

}
export default Application